export enum RoutesEnum {
  KPIDashboard = '/pages/kpi-dashboard',
  RevenueManager = '/pages/revenue-manager',
  Settings = '/pages/settings',
  BookingOverview = '/pages/booking-overview',
  ClusterPricing = '/pages/cluster-pricing-configuration',
  FxRate = '/pages/fx-rate',
  SuperAdminSettings = '/pages/super-admin-settings',
  strategyPriceOverride = '/pages/strategy-price-override',
  PageNotFound = '/page-not-found'
}

export enum RolesEnum {
  ViewerRole = 'viewer',
  EditorRole = 'editor',
  AdminRole = 'admin',
  SuperAdminRole = 'super_admin'
}
